/**
 * An error occurred with server authorization.
 *
 * This event will be emitted anytime a REST request to the server is rejected
 *    due to an authorization issue. This may occur for invalid credentials or
 *    expired tokens, depending on which form of authentication the application
 *    has chosen to use.
 * @public
 * @memberof api
 * @requires restAuthorization
 * @event request:error
 * @param {Object} params
 * @param {api.BasicError} params.error The Basic error object.
 */
export const REQUEST_ERROR = 'request:error'
